const BlockProductCarousel = class extends HTMLElement {
  constructor() {
  super()

  this.swiper = null
  // this.options = JSON.parse(this.dataset.options)
  try {
    this.options = JSON.parse(this.dataset.options || '{}')
  } catch (error) {
    console.error('Invalid JSON in carousel options:', error)
    this.options = {}
  }
  this.prevEl = this.querySelector('[data-block-product-carousel-prev]')
  this.nextEl = this.querySelector('[data-block-product-carousel-next]')
}

connectedCallback () {
  const slider = this.querySelector('.swiper')
  if (!slider) { return }

  const slidesPerView = this.options.slides_per_view === 0 ? 'auto' : this.options.slides_per_view
  const options = {
    ...(this.options.carousel_type === 'fade' && { effect: 'fade' }),
    spaceBetween: 8,
    ...(this.options.autoplay_delay > 0 && {
      autoplay: {
        delay: this.options.autoplay_delay * 1000
      }
    }),
    loop: this.options.loop,
    slidesPerView: 1.5,
    centeredSlides: true,
    breakpoints: {
      750: {
        slidesPerView: slidesPerView || 5,
        centeredSlides: false,
        spaceBetween: 16
      }
    },
    draggable: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    ...(this.prevEl && this.nextEl && {
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl
      }
    })
  }

  this.swiper = new Swiper(slider, options)
  }
}

if (typeof window.customElements.get('block-product-carousel') === 'undefined') {
  window.customElements.define('block-product-carousel', BlockProductCarousel)
}